var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.errorMsg ? _c("el-alert", {
    attrs: {
      title: "错误",
      type: "error",
      description: _vm.errorMsg
    }
  }) : _vm._e(), _c("el-alert", {
    attrs: {
      title: "温馨提示",
      type: "info"
    }
  }, [_c("div", {
    staticClass: "tips"
  }, [_c("p", [_vm._v("高拍仪每次拍摄时会在电脑产生数据, 请定期清理文件夹内图片, 避免占用硬盘容量:")]), _c("p", [_vm._v("\u56FE\u7247\u4E34\u65F6\u6570\u636E\u5730\u5740: C:\\Users\\admin\\Documents\\HttpCamera")]), _c("p", [_vm._v("PDF临时数据地址: D:\\高拍仪")])])]), _c("el-collapse", {
    staticClass: "collapse",
    attrs: {
      accordion: ""
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-collapse-item", {
    attrs: {
      title: "下载高拍仪驱动",
      name: "1"
    }
  }, [_c("a", {
    staticClass: "link",
    attrs: {
      href: "http://sdk.eloam.net/sdk/windows/3/download/",
      target: "_blank"
    }
  }, [_vm._v("驱动下载地址")]), _c("img", {
    staticClass: "pic",
    attrs: {
      src: require("./../pic.png")
    }
  })])], 1), _vm.fileUrl ? _c("img", {
    attrs: {
      src: "data:image/jpg;base64,".concat(_vm.fileUrl)
    }
  }) : _vm._e(), _c("div", {
    staticClass: "base-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      disabled: !_vm.viewer,
      loading: _vm.loading,
      type: "primary"
    },
    on: {
      click: _vm.open
    }
  }, [_vm._v("打开摄像头")]), _c("el-button", {
    attrs: {
      size: "mini",
      disabled: !_vm.viewer,
      loading: _vm.loading,
      type: "danger"
    },
    on: {
      click: _vm.close
    }
  }, [_vm._v("关闭摄像头")]), _c("el-button", {
    attrs: {
      size: "mini",
      disabled: !_vm.viewer,
      loading: _vm.loading,
      type: "info"
    },
    on: {
      click: function click($event) {
        return _vm.rotate(90);
      }
    }
  }, [_vm._v("左转")]), _c("el-button", {
    attrs: {
      size: "mini",
      disabled: !_vm.viewer,
      loading: _vm.loading,
      type: "info"
    },
    on: {
      click: function click($event) {
        return _vm.rotate(270);
      }
    }
  }, [_vm._v("右转")])], 1), _c("img", {
    ref: "viewer",
    staticClass: "img",
    attrs: {
      id: "view1",
      alt: "主摄像头"
    }
  }), _c("div", {
    staticClass: "file-list"
  }, _vm._l(_vm.fileList, function (item, index) {
    return _c("div", {
      key: item,
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        title: "鼠标右键-在新标签页中打开图像可查看大图",
        src: "data:image/jpg;base64,".concat(item),
        alt: ""
      }
    }), _c("cpsc-icon", {
      staticClass: "remove",
      attrs: {
        name: "el-icon-error"
      },
      on: {
        click: function click($event) {
          return _vm.remove(index);
        }
      }
    })], 1);
  }), 0), _c("div", {
    staticClass: "btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      disabled: !_vm.viewer || _vm.fileList.length >= _vm.maxFileLen,
      loading: _vm.loading,
      type: "success"
    },
    on: {
      click: _vm.scan
    }
  }, [_vm._v("拍摄"), _vm.fileList.length === _vm.maxFileLen ? _c("span", [_vm._v("(至多9张)")]) : _vm._e()])], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("上传")]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };